export * from './Icon';
export * from './utils';
export { IconSize } from '../../constants';

import { Icon } from './Icon';
export default Icon;
